const local = {

    en:{
    fttl:"NEW PASSWORD",
    msg:"A new password has been sent to: ",
    submit:"SEND",
    email:"Your Email",
    },

    ru:{
    fttl:"НОВЫЙ ПАРОЛЬ",
    msg:"Ваш новый пароль отправлен на: ",
    submit:"ОТПРАВИТЬ",
    email:"Ваша e-Почта",
    },

    de:{
    fttl:"Neues Passwort",
    msg:"Ihr neues Passwort wurde an folgende E-Mail-Adresse gesendet:",
    submit:"SENDEN",
    email:"Ihre E-Mail",
    },

};

export default local;